enum Product {
  invoiceAdvance = 'Invoice Advance',
  fxSpot = 'fx-spot',
  fxForwards = 'fx-forwards',
  insurance = 'Insurance',
  importFinance = 'import-finance',
}

export { Product }
